import { render, staticRenderFns } from "./packing.vue?vue&type=template&id=7183075e&"
import script from "./packing.vue?vue&type=script&lang=js&"
export * from "./packing.vue?vue&type=script&lang=js&"
import style0 from "./packing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports